export class AgreementStorageDataModel {
  public numberOfSelected = 0;
  public numberOfAll = 0;
  public selected = false;
  public oldSelected = false;
  public expanded = false;

  constructor(
    protected _groupId: number,
    protected parentStorage?: AgreementStorageDataModel
  ) {

    this.incrementNumberOfAllInParent();
  }

  protected incrementNumberOfAllInParent(): void {
    if (this.parentStorage) {
      this.parentStorage.incrementNumberOfAll();
    }
  }

  protected incrementSelectedOfAllInParent(): void {
    if (!this.parentStorage){
      return;
    }

    this.parentStorage.incrementSelected();
  }

  protected decrementSelectedOfAllInParent(): void {
    if (!this.parentStorage){
      return;
    }

    this.parentStorage.decrementSelected();
  }

  public incrementSelected(): void {
    this.numberOfSelected++;

    this.updateSelectedStatus();
  }

  public decrementSelected(): void {
    this.numberOfSelected--;

    this.updateSelectedStatus();
  }

  public incrementNumberOfAll(): void {
    this.numberOfAll++;

    this.updateSelectedStatus();
  }

  public checkedAll(): void {
    this.numberOfSelected = this.numberOfAll;

    this.updateSelectedStatus();
  }

  public uncheckedAll(): void {
    this.numberOfSelected = 0;

    this.updateSelectedStatus();
  }

  private updateSelectedStatus(): void {
    this.selected = this.numberOfSelected === this.numberOfAll;

    if (this.selected !== this.oldSelected) {
      this.selected ? this.incrementSelectedOfAllInParent() : this.decrementSelectedOfAllInParent();
    }

    this.oldSelected = this.selected;
  }

}
